import React, { useState } from "react";
import { orderService } from "../services/orderService";
import styles from "../styles/Admin.module.css";

const TrackOrder: React.FC = () => {
  const [id, setOrderId] = useState("");
  const [order, setOrder] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const handleTrack = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setOrder(null);

    try {
      const res = await orderService.getById(id); 

      if (!res) {
        setMessage("No order found with that Order ID.");
        return;
      }

      setOrder(res);
    } catch (err: any) {
      console.error("Error tracking order:", err);

      if (err.response?.status === 401) setMessage("You must be logged in to view this order.");
      else if (err.response?.status === 403) setMessage("You cannot access this order.");
      else if (err.response?.status === 404) setMessage("Order not found.");
      else setMessage("Invalid or incorrect Order ID.");
    } finally {
      setLoading(false);
    }
  };

  const formatPrice = (num: number) =>
    num?.toLocaleString("en-US") ?? num;

  return (
    <div className={styles["admin-container"]}>
      <div className={`${styles.card} ${styles["p-6"]} ${styles["rounded"]}`}>
        <h2 className={styles["admin-header"]}>Track Your Order</h2>
        <p className={styles.subtitle}>Enter your Order ID to view your order status.</p>

        <form onSubmit={handleTrack} className={styles["track-form"]}>
          <div className={styles["form-group"]}>
            <label>Order ID</label>
            <input 
              type="text"
              placeholder="e.g. 67e4fda9342c1a4ed"
              value={id}
              onChange={(e) => setOrderId(e.target.value)}
              className={styles.inputField}
              required
            />
          </div>
          <br />
          <button type="submit" className={styles.adminAddButton} disabled={loading}>
            {loading ? "Tracking..." : "Track Order"}
          </button>
        </form>

        {message && <p className={styles.message}>{message}</p>}
      </div>

      {order && (
        <div className={`${styles.card} ${styles["mt-4"]} ${styles["p-6"]} ${styles["rounded"]}`}>
          <div className={styles["info-grid"]}>
            <p><strong>Status:</strong>
              <span className={`${styles["status-badge"]} ${styles[order.status?.toLowerCase()]}`}>
                {order.status}
              </span>
            </p>
          </div>
        </div>
      )}

      {/* Modal */}
      {selectedImage && (
        <div className={styles["modal-overlay"]} onClick={() => setSelectedImage(null)}>
          <div className={styles["modal-content"]} onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Selected" className={styles["modal-image"]} />
            <button className={styles["close-btn"]} onClick={() => setSelectedImage(null)}>×</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrackOrder;
